import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoaderComponent } from 'app/components/loader/loader.component';
import { Booking, Customer, Vehicle } from 'app/models/customer';
import { LoginCustomer } from 'app/models/login-customer';
import { SystemConstValues } from 'app/models/system-const-values';
import { BehaviorSubject } from 'rxjs';
import { StorageService } from './storage.service';
import * as CryptoJS from 'crypto-js';

@Injectable({
    providedIn: 'root',
})
export class UtilService {
    encryptionKey: string = '!!!!mmm_Enc_Key@@@@';

    private progressRef: OverlayRef | undefined;
    public loginChangeObx: BehaviorSubject<Customer | null>;
    public systemConstValuesObx: BehaviorSubject<SystemConstValues | null>;
    public bookingDetailsObx: BehaviorSubject<Booking | null>;

    constructor(
        private storageService: StorageService,
        private overlay: Overlay,
    ) {
        this.loginChangeObx = new BehaviorSubject<Customer | null>(this.storageService.getCurrentCustomer());
        this.systemConstValuesObx = new BehaviorSubject<SystemConstValues | null>(null);
        this.bookingDetailsObx = new BehaviorSubject<Booking | null>(null);
    }

    createOverlayRef() {
        // Globally centered position strategy
        const positionStrategy = this.overlay
            .position()
            .global()
            .centerHorizontally()
            .centerVertically();

        // Create the overlay with customizable options
        this.progressRef = this.overlay.create({
            positionStrategy,
            hasBackdrop: true,
            backdropClass: 'overlay-backdrop',
            panelClass: 'overlay-panel',
            disposeOnNavigation: true,
        });
    }

    showLoader() {
        if (this.progressRef != undefined) {
            this.hideLoader();
        }
        this.createOverlayRef();
        var portal = new ComponentPortal(LoaderComponent);
        this.progressRef?.attach(portal);
    }

    hideLoader() {
        this.progressRef?.dispose();
    }

    setBookingDetails(booking: Booking) {
        this.bookingDetailsObx.next(booking);
    }

    loginCustomer(rCustomer: LoginCustomer) {
        this.storageService.setSessionToken(rCustomer.token);
        this.storageService.setCurrentCustomer(rCustomer.customer);
        this.loginChangeObx.next(rCustomer.customer);
    }

    formatString(str: string, ...val: string[]) {
        for (let index = 0; index < val.length; index++) {
            str = str.replace(`{${index}}`, val[index]);
        }
        return str;
    }

    showSuccessSnack(matSnackBar: MatSnackBar, message: string, duration: number = 5000): void {
        if (message) {
            matSnackBar.open(message, undefined, {
                duration: duration,
                panelClass: ['green-snackbar'],
                horizontalPosition: 'center',
                verticalPosition: 'top',
            });
        }
    }

    showErrorSnack(matSnackBar: MatSnackBar, message: string, duration: number = 5000): void {
        if (!message) {
            message = 'We encountered an issue. Please try again later.';
        }

        matSnackBar.open(message, undefined, {
            duration: duration,
            panelClass: ['red-snackbar'],
            horizontalPosition: 'center',
            verticalPosition: 'top',
        });
    }

    encode(value: any) {
        return CryptoJS.AES.encrypt(value, this.encryptionKey).toString();
        // return window.btoa(value);
    }

    decode(value: any) {
        return CryptoJS.AES.decrypt(value, this.encryptionKey).toString(CryptoJS.enc.Utf8);
        // return window.atob(value);
    }

    public saveAsFile(data: HttpResponse<Blob>, name: string): void {
        const blob = data.body;
        const url = window.URL.createObjectURL(blob ?? new Blob());
        const anchor = document.createElement('a');
        anchor.download = name;
        anchor.href = url;
        anchor.click();
    }
}
